import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

export interface QueryFilterIconProps {
    member: string;
    filterable: boolean;
    filtered: boolean;
    onFilter: (member: string, event: any) => void;
    automationid?: string;
}

export const QueryFilterIcon = (props: QueryFilterIconProps) => {
    const { member, filterable, filtered, onFilter } = props;
    const handleFilter = _event => onFilter(member, onFilter);

    if (filtered || filterable) {
        return (
            <a
                onClick={handleFilter}
                data-automationid={props.automationid}
                style={{ paddingLeft: "8px" }}
            >
                <FontAwesomeIcon icon={faFilter} className={filtered ? "text-info" : ""} />
            </a>
        );
    }

    return null;
};
